module.exports = __webpack_public_path__ + "r-v3/img/virtual_background_blur.2ab8d436.png";